import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../utils/Helpers'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { GET_SKU_OFFERS_DUPLICATED } from '../../../queries/events'

const OffersSku = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_SKU_OFFERS_DUPLICATED, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Ofertas com SKU duplicado" number={formatNumber(data.eventOfferIntegrationDatabaseCount)}/>
  )
}

export default OffersSku
